export const STEPS = {
  1: {
    title: 'トライオートへようこそ！',
    message: 'チュートリアルでは​「オートセレクト」を​\n使った​自動売買の​始め方を​ご紹介します',
  },
  2: {
    title: 'まず​「セレクト」から\n「オートセレクト」を​クリックします',
    message: 'オートセレクトは​簡単な​質問に​答えるだけで、\nあなたに​ピッタリな​自動売買を​ご提案します',
  },
  3: {
    title: '３つの​質問に​答えます',
    message: '運用金額、戦略、​運用方​針を​もとに​\n自動売買の​ポートフォリオが​作成されます',
  },
  4: {
    title: 'シミュレーションを確認し、\n確認画面へ進みます',
    message: '過去の相場の損益をチェックして、\n確認画面へ進みましょう',
  },
  5: {
    title: '最後に、​内容を​確認して、\nオートセレクトを​開始します',
    message: 'これで​自動売買の​運用が​はじまります',
  },
  6: {
    title: '自動売買の運用を見守ります',
    message: '自動売買の運用成績を確認しましょう\nカレンダーで毎日の損益がわかります',
  },
  7: {
    title: 'セミナーやレポートを活用し、\n理解を深めましょう',
    message: 'セミナー等で自動売買を気軽に学べます\nご不明点はお気軽にお問合せください',
  },
  8: {
    title: '運用資金を入金して\n自動売買を始めましょう',
    message: '早速、入金をして取引を始めましょう\n即時入金で資金がすぐに反映されます',
  },
};
